import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-731a297c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "after-sale-log-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-more" }, "No more~", -1))

import { inject, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import {  getFilePath } from '@/hooks/index'
import Header from '@/components/header/header.vue'
import DetailCardNew from './component/afterDetailsCardNew.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'afterSaleLogInfo',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const $http: any = inject('$http')
/** detailCardData 详情卡片模块数据说明
 * title:'' 当前详情模块标题
 * textData:[]  当前模块文字数据
 * fileList: [], 当前模块图片视频数据
 * transit: {}, // 当前模块物流信息数据
 */
let detailCardData: any = ref([])
let imgPathData = {}


// 获取并处理详情数据
const getAfterSaleDetail = async () => {
  const filePathRes: any = await getFilePath() // 获取视频/图片拼接路径及格式
  if (filePathRes) {
    imgPathData = filePathRes
  }
  const res: any = await $http.getAfterSaleDetail({ id: route.params.id })
  if (res.code === 200) {
    const DETAIL = JSON.parse(JSON.stringify(res.data))
    DETAIL.actions.forEach((item:any) => {
      const textData:any = []
      item.content.values.forEach((valueItem:any) => {
        const textItem = {
          label: valueItem.title_en,
          value: valueItem.value,
          isShowViewTrack: valueItem.value_type,
          noBetween: true
        }
        textData.push(textItem)
      })
      const obj = {
        isAvatar: true,
        avatar: {
          operator_role: item.operator_role,
          title: item.content.title.title_en,
          created_at: item.created_at
        },
        fileList: [],
        textData: textData
      }
      handleAttachments(obj.fileList,item.attachments)
      detailCardData.value.push(obj)
    })
  }
}
// 处理展示的附件
const handleAttachments = (fileList: any, file: any) => {
  // 进行视频/图片拼接路径及格式设置
  if (file && file.length) {
    let fileData = {}
    // 展示的附件处理
    file.forEach((item: any) => {
      fileData = {
        content:
          item.attach_type == 1
            ? item.content
            : item.content.replace(
                imgPathData.media_suffix,
                imgPathData.media_image_suffix
              ),
        attach_type: item.attach_type
      }
      fileList.push(fileData)
    })
  }
}

const handleLogistics = (num:any) => {
  router.push(`/logistics/${num}`)
}
getAfterSaleDetail()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, {
      title: "Aftersale Log Information",
      backgroundColor: "#FFFFFF",
      fontColor: "#303133",
      ios_app: true
    }),
    _createVNode(DetailCardNew, {
      detailData: _unref(detailCardData),
      onLogistics: handleLogistics
    }, null, 8, ["detailData"]),
    _hoisted_2
  ]))
}
}

})